export const btnCancel = {
  color: "#0E8750",
  borderRadius: "10px",
  fontFamily: "'Nunito', sans-serif",
  background: "#F8F8F9",
  border: "1px solid #DEDEE9",
  width: "200px",
};
